<div class="message message-warning">
  <%= validated_invalid_patient_type_message_reason %>
</div>
